"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECRET_KEY_LENGTH = exports.AES_IV_PLUS_TAG_LENGTH = exports.AES_TAG_LENGTH = exports.AES_IV_LENGTH = exports.UNCOMPRESSED_PUBLIC_KEY_SIZE = void 0;
exports.UNCOMPRESSED_PUBLIC_KEY_SIZE = 65;
exports.AES_IV_LENGTH = 16;
exports.AES_TAG_LENGTH = 16;
exports.AES_IV_PLUS_TAG_LENGTH = exports.AES_IV_LENGTH + exports.AES_TAG_LENGTH;
exports.SECRET_KEY_LENGTH = 32;
